import moment from "moment";

export default function(yyyyMM) {
    if (!yyyyMM) return new Handlebars.SafeString("");
    var time = moment(yyyyMM, "YYYYMM");
    return moment(time).format("MMM 'YY");
}